/* ICAO prefix → IANA zone. Longest prefix wins, so an airport overrides its country. */

const ZONE_BY_PREFIX = [
  // Country prefix
  ["BI", "Atlantic/Reykjavik"],
  ["BK", "Europe/Belgrade"],
  ["EB", "Europe/Brussels"],
  ["ED", "Europe/Berlin"],
  ["EE", "Europe/Tallinn"],
  ["EF", "Europe/Helsinki"],
  ["EG", "Europe/London"],
  ["EH", "Europe/Amsterdam"],
  ["EI", "Europe/Dublin"],
  ["EK", "Europe/Copenhagen"],
  ["EN", "Europe/Oslo"],
  ["EP", "Europe/Warsaw"],
  ["ES", "Europe/Stockholm"],
  ["ET", "Europe/Berlin"],
  ["EV", "Europe/Riga"],
  ["EY", "Europe/Vilnius"],
  ["GC", "Atlantic/Canary"],
  ["GM", "Africa/Casablanca"],
  ["HE", "Africa/Cairo"],
  ["LA", "Europe/Tirane"],
  ["LB", "Europe/Sofia"],
  ["LC", "Asia/Nicosia"],
  ["LD", "Europe/Zagreb"],
  ["LE", "Europe/Madrid"],
  ["LF", "Europe/Paris"],
  ["LG", "Europe/Athens"],
  ["LH", "Europe/Budapest"],
  ["LI", "Europe/Rome"],
  ["LJ", "Europe/Ljubljana"],
  ["LK", "Europe/Prague"],
  ["LM", "Europe/Malta"],
  ["LO", "Europe/Vienna"],
  ["LP", "Europe/Lisbon"],
  ["LQ", "Europe/Sarajevo"],
  ["LR", "Europe/Bucharest"],
  ["LS", "Europe/Zurich"],
  ["LT", "Europe/Istanbul"],
  ["LW", "Europe/Skopje"],
  ["LY", "Europe/Belgrade"],
  ["LZ", "Europe/Bratislava"],
  ["OM", "Asia/Dubai"],
  ["UG", "Asia/Tbilisi"],

  // Airport prefix. The country above has a second civil time.
  ["EKVG", "Atlantic/Faroe"], // Vágar, Faroe Islands.
  ["ENSB", "Arctic/Longyearbyen"], // Longyearbyen, Svalbard.

  // Azores.
  ["LPAZ", "Atlantic/Azores"],
  ["LPCR", "Atlantic/Azores"],
  ["LPFL", "Atlantic/Azores"],
  ["LPGR", "Atlantic/Azores"],
  ["LPHR", "Atlantic/Azores"],
  ["LPLA", "Atlantic/Azores"],
  ["LPPD", "Atlantic/Azores"],
  ["LPPI", "Atlantic/Azores"],
  ["LPSJ", "Atlantic/Azores"],

  // Madeira.
  ["LPMA", "Atlantic/Madeira"],
  ["LPPS", "Atlantic/Madeira"],
]

// Longer codes first, so ENSB matches before EN and LPPD before LP.
const ZONES_BY_LENGTH = [...ZONE_BY_PREFIX].sort((a, b) => b[0].length - a[0].length)

export function zoneForIcao(icao) {
  const code = String(icao || "")
    .trim()
    .toUpperCase()
  if (!code) return null
  for (const [prefix, zone] of ZONES_BY_LENGTH) {
    if (code.startsWith(prefix)) return zone
  }
  return null
}

function utcClock(value) {
  const raw = String(value ?? "").replace(/[T,Z]/g, " ")
  return raw.split(" ")[1]?.substring(0, 5) || ""
}

function parseUtc(value) {
  const raw = String(value ?? "").trim()
  if (!raw) return null
  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) return new Date(raw)
  const normalized = raw.replace(" ", "T")
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) return new Date(`${normalized}:00Z`)
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(normalized)) return new Date(`${normalized}Z`)
  return new Date(raw)
}

function formatInZone(date, zone) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: zone,
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date)
  const hour = parts.find((part) => part.type === "hour")?.value
  const minute = parts.find((part) => part.type === "minute")?.value
  if (!hour || !minute) return ""
  return `${hour}:${minute}`
}

export function formatStationTime(utcIso, icao, mode) {
  const utc = utcClock(utcIso)
  if (!utc || mode !== "lt") return utc
  const zone = zoneForIcao(icao)
  if (!zone) return utc
  const date = parseUtc(utcIso)
  if (!date || Number.isNaN(date.getTime())) return utc
  return formatInZone(date, zone) || utc
}
